import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createClient } from '@connectrpc/connect';
import { useQuery } from '@tanstack/react-query';
import { AdminService } from 'proto/gen/ts/shirt/v1/admin_pb';
import { Link } from 'react-router-dom';
import { transport } from '../../utils/transport';
const adminClient = createClient(AdminService, transport);
export default function AdminDashboard() {
    const { data, isLoading } = useQuery({
        queryKey: [
            'adminDashboard'
        ],
        queryFn: ()=>adminClient.getDashboard({})
    });
    return /*#__PURE__*/ _jsxs("div", {
        className: "max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "font-heading text-2xl font-bold text-stone-900 mb-6",
                children: "Dashboard"
            }),
            isLoading || !data ? /*#__PURE__*/ _jsx("p", {
                className: "text-stone-500",
                children: "Loading stats..."
            }) : /*#__PURE__*/ _jsxs("div", {
                className: "grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "bg-white border-2 border-stone-100 p-5",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-xs text-stone-500 uppercase tracking-wider mb-1",
                                children: "Users"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "font-heading text-3xl font-bold text-stone-900",
                                children: Number(data.totalUsers)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "bg-white border-2 border-stone-100 p-5",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-xs text-stone-500 uppercase tracking-wider mb-1",
                                children: "Products"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "font-heading text-3xl font-bold text-stone-900",
                                children: Number(data.totalProducts)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "bg-white border-2 border-stone-100 p-5",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-xs text-stone-500 uppercase tracking-wider mb-1",
                                children: "Orders"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "font-heading text-3xl font-bold text-stone-900",
                                children: Number(data.totalOrders)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "bg-white border-2 border-stone-100 p-5",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-xs text-stone-500 uppercase tracking-wider mb-1",
                                children: "To Pack"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "font-heading text-3xl font-bold text-stone-900",
                                children: Number(data.ordersToPack)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("h2", {
                className: "font-heading text-lg font-semibold text-stone-900 mb-3",
                children: "Quick Actions"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "grid grid-cols-1 sm:grid-cols-2 gap-4",
                children: [
                    /*#__PURE__*/ _jsxs(Link, {
                        to: "/admin/products",
                        className: "bg-white border-2 border-stone-100 p-5 hover:border-stone-300",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: "font-heading font-semibold text-stone-900",
                                children: "Manage Products"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-stone-500 mt-1",
                                children: "Add, edit, or remove products."
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Link, {
                        to: "/admin/orders",
                        className: "bg-white border-2 border-stone-100 p-5 hover:border-stone-300",
                        children: [
                            /*#__PURE__*/ _jsx("h3", {
                                className: "font-heading font-semibold text-stone-900",
                                children: "Orders"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-stone-500 mt-1",
                                children: "Review recent orders."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
